import { render, staticRenderFns } from "./SetpointsTable.vue?vue&type=template&id=0cd19acd&scoped=true"
import script from "./SetpointsTable.vue?vue&type=script&lang=ts"
export * from "./SetpointsTable.vue?vue&type=script&lang=ts"
import style0 from "./SetpointsTable.vue?vue&type=style&index=0&id=0cd19acd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd19acd",
  null
  
)

export default component.exports